module.exports = __webpack_public_path__ + "fonts/Manrope-500-greek9_f91e858.woff2";